import { gql } from "@apollo/client";
import { OrgId } from "../../domain/orgId/types";
import client from "graphql/client";

const INSERT_ORG_ID = gql`
  query INSERT_ORG_ID(
    $org_id: smallint
    $display_name: String
    $org_params: json
    $org_id_description: String
  ) {
    pp_org_id_insert(
      args: {
        _org_id: $org_id
        _display_name: $display_name
        _org_params: $org_params
        _desk: $org_id_description
      }
    ) {
      json_value
    }
  }
`;

const useInsertOrgId = () => {
  const query = (variables: OrgId) => {
    return client.query({
      query: INSERT_ORG_ID,
      fetchPolicy: "no-cache",
      variables,
    });
  };

  return query;
};

export default useInsertOrgId;
